import { Colors } from 'src/compass/shared/util/Colors';

interface IColorRow {
  [key: string]: any; // Allow other dynamic keys
  recordType: keyof typeof Colors;
}

export const getColorByDateStatus = (row: IColorRow) => ({
  backgroundColor: Colors[row.recordType],
});
